import { Link } from "react-router-dom";
import { ShieldCheck, Printer, ArrowLeft, DownloadSimple } from "@phosphor-icons/react";

// Shared shell for the printable one-page handouts. The toolbar is hidden in
// print output; the .print-sheet renders as a single A4 page (see index.css).
export function HandoutShell({ children, testid }) {
  return (
    <div className="min-h-screen aurora grain py-8 px-4 flex flex-col items-center" data-testid={testid}>
      <div className="no-print w-full max-w-[210mm] flex items-center justify-between mb-4">
        <Link to="/" className="btn-ghost text-sm" data-testid="handout-home-btn">
          <ArrowLeft size={14} /> Home
        </Link>
        <button
          onClick={() => window.print()}
          className="btn-gold text-sm"
          data-testid="handout-print-btn"
        >
          <DownloadSimple size={15} weight="fill" /> Download PDF
        </button>
      </div>
      <div className="print-sheet glass rounded-2xl w-full max-w-[210mm] p-10 relative overflow-hidden">
        {children}
      </div>
      <div className="no-print text-xs text-white/40 mt-4 flex items-center gap-2">
        <Printer size={13} /> Tip: choose “Save as PDF” in the print dialog for a shareable one-pager.
      </div>
    </div>
  );
}

export function HandoutBrand({ tag }) {
  return (
    <div className="flex items-center justify-between hairline-b pb-5 mb-6">
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-xl flex items-center justify-center gold-glow" style={{ background: "#FFB020" }}>
          <ShieldCheck size={24} weight="duotone" color="#050B0A" />
        </div>
        <div>
          <div className="font-display text-xl leading-none">PerCen360</div>
          <div className="text-[10px] tracking-[0.22em] uppercase text-white/50 mt-1">Compliance Finance OS</div>
        </div>
      </div>
      <div className="eyebrow text-[10px]">{tag}</div>
    </div>
  );
}

export function FeatureItem({ icon: Icon, title, desc, color = "#FFB020" }) {
  return (
    <div className="flex items-start gap-3">
      <div
        className="w-9 h-9 rounded-lg flex items-center justify-center border border-white/10 bg-black/30 shrink-0"
      >
        <Icon size={17} weight="duotone" color={color} />
      </div>
      <div>
        <div className="font-display text-[15px] leading-tight">{title}</div>
        <div className="text-[12px] text-white/60 leading-snug mt-0.5">{desc}</div>
      </div>
    </div>
  );
}

export function HandoutFooter() {
  return (
    <div className="hairline-b border-b-0 border-t border-white/10 pt-4 mt-7 flex flex-wrap items-center justify-between gap-2 text-[11px] text-white/50">
      <span>percen360.com · GDPR-native · Revenue.ie rule-checked · EU region</span>
      <span className="text-[#FFB020]">gillian@percen360.com</span>
    </div>
  );
}
